import { Inject, Options, Vue } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-admin-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import { orderBy } from "lodash";
import { PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import ConfirmDialogue from "@/shared/components/confirm-dialogue/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';

@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    ConfirmDialogue,
  },
  mixins: [FormatDateTimeMixin],
})
export default class PracticePeopleAuthorisedTrustContact extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private searchKeyword = '';
  private showActiveOnly = false;
  private sortMethod = 'asc';
  private activeSortHeader = 0;

  private trustContacts: any[] = [];
  private trustContactsDisplay: any = [];

  private loadingContent = false;
  private errorLoadingContent = false;
  private loadingDataSet = false;
  private errorLoadingDataSet = false;

  private showAddEditModal = false;

  private tableHeadings = [
    { text: 'LawID', value: 'lawId', sortable: true, sortMethod: 'asc' },
    { text: 'Name', value: 'name', sortable: true, sortMethod: 'acs' },
    { text: 'Email', value: 'email', sortable: true, sortMethod: 'acs' },
    { text: 'From', value: 'effectiveStartDate', sortable: true, sortMethod: 'acs' },
    { text: 'To', value: 'effectiveEndDate', sortable: true, sortMethod: 'acs' },
    { text: 'Action', value: '', sortable: false, sortMethod: 'acs' },
  ];

  mounted() {
    this.loadTableData();
  }

  private loadTableData() {
    this.loadingContent = true;
    this.errorLoadingContent = false;
    this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleAdminGetTrustContactsPracticeIdGet(this.selectedPractice.id)
      .then((res: any) => {
        this.trustContacts = res.data.data ?? [];
        this.trustContactsDisplay = this.trustContacts;
        for (let i = 0; i < this.trustContacts.length; i++) {
          this.trustContactsDisplay[i].name = this.trustContacts[i].firstName + ' ' + this.trustContacts[i].lastName;
        }
        this.sortTableColumn(4, true);
        this.loadingContent = false;
      })
      .catch((err: any) => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to get Authorised Trust Contact list: ' + err);
        this.ai.trackException('Error, Unable to get Authorised Trust Contact list: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })
  }

  private sortTableColumn(index: number, sortable: boolean) {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        this.tableHeadings[index].sortMethod = this.sortMethod;
        if (this.trustContacts.length > 0) {
          const nameSorter = index == 1 ? (c: any) => c.name.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.name.toLowerCase()];
          const orderByResults = orderBy(
            this.trustContacts,
            nameSorter,
            [this.sortMethod as any]
          );
          this.trustContactsDisplay = orderByResults;
        }
      }
    }
  }

  private applyFilter(data: any) {
    if (this.searchKeyword == '') return data;
    const _result = data.filter((d: any) => {
      return (d.name.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0) || (d.lawId.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0);
    })
    return _result;
  }

  private isActive(i: any): boolean {
    const _terminatedDate = i.effectiveEndDate ?? null;
    if (_terminatedDate) {
      return false;
    } else {
      return true;
    }
  }

  private deleteTrustContact(i: any): void {
    const _confirm: any = this.$refs.confirmDeleteDialogue;
    _confirm.show({
      title: 'Delete Authorised Trust Contact',
      message: 'Are you sure you want to delete <b>' + i.name + '</b>, identified by contact email <b>' + i.email + '</b>?',
      okButton: 'Delete',
      cancelButton: 'Cancel',
    }).then((res: any) => {
      if (res) {
        this.deleteIt(i);
      }
    })
  }

  private async deleteIt(i: any): Promise<void> {
    await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleAdminTerminateTrustContactIndividualPracticeIdPut(i.individualPracticeId)
      .then(() => {
        this.eventCtrl.emit('show-snackbar', 'success', 'Authorised Trust Contact has been deleted');
        this.loadTableData();
      }).catch((err: any) => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to delete Authorised Trust Contact: ' + err);
        this.ai.trackException('Error, Unable to delete Authorised Trust Contact: ' + err);
      });
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

}


